export function createProductionRequestGate({
  createController = () => new AbortController(),
  trace = () => {},
} = {}) {
  let currentId = 0;
  let controller = null;

  return {
    begin(reason = "explicit-request") {
      trace("generation-begin", { generation: currentId + 1, reason });
      controller?.abort();
      controller = createController();
      const id = ++currentId;
      return {
        id,
        signal: controller.signal,
        isCurrent: () => id === currentId,
        finish: () => {
          if (id === currentId) controller = null;
        },
      };
    },
    cancel(source = "unmount") {
      trace("generation-cancel", { generation: currentId, source });
      controller?.abort();
      controller = null;
      currentId += 1;
    },
  };
}
